import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 96px 28px;
        gap: 60px;
    `,
    "Title": styled.h1`
        ${({ theme }) => theme.font["heading-bold"]};
    `,

    "Form": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    `,
    "Result": styled.div`
        text-align: center;
        ${({ theme }) => theme.font["small-medium"]};
        border-top: 1px solid ${({ theme }) => theme.color["grey2"]};
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};
        padding: 8px 0;

        & > span {
            ${({ theme }) => theme.font["large-semibold"]};
            color: ${({ theme }) => theme.color["blue"]};
        }
    `,

    "ButtonDiv": styled.div`
        width: 100%;
    `,

    "movePageButton": styled.button`
        ${({ theme }) => theme.font["small-semibold"]};
    `,
}